"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _clientAwsS = require("@devsta/client-aws-s3");

var _uiKit = require("@devsta/ui-kit");

var _ContentPlaceholder = _interopRequireDefault(require("../../../../../../../common/components/ContentPlaceholder"));

var _Campaign = _interopRequireDefault(require("./Campaign"));

require("../styles/_active-campaigns.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // function normaliseDate(date) {
//   return date ? moment(date, 'x') : moment();
// }


var ActiveCampaigns = /*#__PURE__*/function (_Component) {
  _inherits(ActiveCampaigns, _Component);

  function ActiveCampaigns() {
    var _this;

    _classCallCheck(this, ActiveCampaigns);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ActiveCampaigns).call(this));

    _defineProperty(_assertThisInitialized(_this), "fetchActiveCampaigns", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, getAllActiveCampaigns, organisationId, _ref2, data, error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, getAllActiveCampaigns = _this$props.getAllActiveCampaigns, organisationId = _this$props.organisationId;

              _this.setState({
                activeCampaigns: void 0
              });

              _context.next = 4;
              return getAllActiveCampaigns({
                organisationId: organisationId,
                isPublic: true
              });

            case 4:
              _ref2 = _context.sent;
              data = _ref2.data;
              error = _ref2.error;

              if (!(!data || error || !data.getAllActiveCampaigns)) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", void _this.setState({
                activeCampaigns: []
              }));

            case 9:
              // const displayableCampaigns = data.getAllActiveCampaigns.filter(({ startDate, endDate }) => (
              //   moment().isBetween(normaliseDate(startDate), normaliseDate(endDate), null, '[]')
              // ));
              // this.retrieveBucketKeyUrls(displayableCampaigns);
              _this.retrieveBucketKeyUrls(data.getAllActiveCampaigns);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "retrieveBucketKeyUrls", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(activeCampaigns) {
        var apiClient, activeCampaignsWithImages;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                apiClient = _this.props.apiClient;
                _context2.prev = 1;
                _context2.next = 4;
                return (0, _clientAwsS.replaceBucketKeysWithUrlsInArray)({
                  apiClient: apiClient,
                  dataArray: activeCampaigns,
                  substitutedKeys: ['coverImageKey']
                });

              case 4:
                activeCampaignsWithImages = _context2.sent;

                _this.setState({
                  activeCampaigns: activeCampaignsWithImages
                });

                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);

                _this.setState({
                  activeCampaigns: activeCampaigns
                });

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 8]]);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());

    _this.state = {
      activeCampaigns: void 0
    };
    return _this;
  }

  _createClass(ActiveCampaigns, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchActiveCampaigns();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var organisationId = this.props.organisationId;

      if (prevProps.organisationId !== organisationId) {
        this.fetchActiveCampaigns();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          openViewPostModal = _this$props2.openViewPostModal,
          fetchAssets = _this$props2.fetchAssets,
          history = _this$props2.history;
      var activeCampaigns = this.state.activeCampaigns;

      if (!activeCampaigns) {
        return _react.default.createElement(_ContentPlaceholder.default, null);
      }

      if (!activeCampaigns.length) {
        return null;
      }

      return _react.default.createElement("div", {
        className: "active-campaigns"
      }, _react.default.createElement(_uiKit.Text, {
        heading3: true,
        prefixIcon: "broadcast"
      }, "Campaigns"), _react.default.createElement(_uiKit.Carousel, {
        slidesToShow: 1
      }, activeCampaigns.map(function (campaign) {
        return _react.default.createElement(_Campaign.default, {
          key: campaign.inspirationCampaignId,
          openViewPostModal: openViewPostModal,
          campaign: campaign,
          fetchAssets: fetchAssets,
          history: history
        });
      })));
    }
  }]);

  return ActiveCampaigns;
}(_react.Component);

exports.default = ActiveCampaigns;